import * as types from '../mutation-types';
import banks from '../../api/banks';
import businesses from '@/api/businesses';
import accounts from '../../api/accounts';
import users from '@/api/user';
import _ from 'lodash';

const state = {
  banks: [
    {
      id: null
    }
  ],
  selected: {
    id: null,
    logo: null,
    users: [
      {
        id: null
      }
    ],
    referrals: [
      {
        id: null
      }
    ]
  }
};

const getters = {
  BanksList: state => state.banks,
  SelectedBank: state => state.selected
};

const actions = {
  async getBanksList({ commit, dispatch, state, rootGetters }) {
    try {
      const res = await banks.getBanksList();
      let banksList;
      if (rootGetters.UserHasRole('Bank')) {
        banksList = res.data.filter(bank => rootGetters.UserBusinesses.includes(bank.id));
      } else {
        banksList = res.data;
      }
      commit(types.SET_BANKS_LIST, banksList);
      if (_.isNull(state.selected.id)) {
        dispatch('selectBank', banksList[0].id);
      }
    } catch (error) {
      console.error(error);
    }
  },
  selectBank({ commit }, id) {
    banks.getBank(id).then(bank => commit(types.SET_SELECTED_BANK, bank.data));
  },
  updateBank({ dispatch }, { id, updates }) {
    businesses.update(id, updates).then(() => {
      dispatch('addNotification', {
        text: 'Bank details have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
      dispatch('getBanksList');
    });
  },
  updateBankUser({ dispatch, state }, { id, updates }) {
    const bankId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .updateUser(id, updates)
        .then(() => {
          dispatch('selectBank', bankId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  sendBankWelcomeMessage({ dispatch, state }, id) {
    const bankId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .sendWelcomeMessage(id)
        .then(() => {
          dispatch('selectBank', bankId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  addBank({ dispatch }, details) {
    return new Promise((resolve, reject) => {
      accounts
        .register(details)
        .then(() => {
          dispatch('getBanksList');
          resolve();
        })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [types.SET_BANKS_LIST](state, banks) {
    state.banks = banks;
  },
  [types.SET_SELECTED_BANK](state, bank) {
    state.selected = bank;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
